<template>
  <div>
    <div class="el-input">
      <el-input type="text" :value="val" style="text-align: right" maxlength="24" @input="change($event)" >
        <template slot="append">%</template>
      </el-input>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      val: 0
    }
  },
  mounted () {
    if (parseFloat(this.value).toString() !== 'NaN') {
      this.val = (this.value === undefined ? 0 : parseFloat((parseFloat(this.value) * 100.0 - 100.0).toFixed(2)))
    }
  },
  props: ['value'],
  methods: {
    change: function (val) {
      if (parseFloat(val).toString() !== 'NaN') {
        this.val = val
        this.$emit('input', ((parseFloat(this.val) + 100.0) / 100.0).toFixed(4))
      } else {
        this.val = ''
      }
    }
  },
  watch: {
    value: function (val, oldVal) {
      if (parseFloat(val).toString() !== 'NaN') {
        this.val = (this.value === undefined ? 0 : parseFloat((parseFloat(this.value) * 100.0 - 100.0).toFixed(2)))
      } else {
        this.val = ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/card/components/VirtualPercentInput.vue